import createPersistedState from "vuex-persistedstate";

import userData from "./modules/userData";
import company from "./modules/company";
import filterOptions from "./modules/filterOptions";
import alert from "./modules/alert";

import { tooltipJson } from "./../Options/tooltip";

//initiliase store for Vuex
const store = {
    plugins: [createPersistedState({})],
    state: {
        filterUrl: "",
        updateData: 0,
        lastData: null,
        modules: null,
        lastDataLateCheck: null,
        lastDataExitCheck: null,
        tooltip: tooltipJson,

        truckData: null,
        driverData: null,
        defectData: null,
        nosData: null,
        initialDataToEdit: null,
    },
    modules: {
        userData,
        company,
        filterOptions,
        alert,
    },
    actions: {
        setInitialDataToEdit({ commit }, data) {
            commit("setInitialDataToEdit", data);
        },
    },
    mutations: {
        setInitialDataToEdit(state, data) {
            state.initialDataToEdit = data;
        },
    },
};

export default store;
